<template>
    <div class="centent">
        <el-carousel  indicator-position="outside" :interval="5000" arrow="never" height="400px" class="carousel_box">
            <el-carousel-item v-for="item in list" :key="item.uuid">
                <div class="flex-row carousel_item">
                    <div class="mesg_box">
                        <p class="title">
                            {{ item.name }}
                        </p>
                        <p class="content">
                            {{ item.summary }}
                        </p>

                        <p class="tpis" @click="getSolutionDetail(item.uuid)">查看详情 ></p>
                    </div>
                    <img :src="item.thumbnailUrl" alt="" srcset="">
                </div>
            </el-carousel-item>
        </el-carousel>
        <div class="new_center_more" @click="getNewsMore">查看更多 ></div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {

        }
    },
    created() { },
    methods: {
        getSolutionDetail(uuid) {
            //this.$router.push({ name: "caseDetails", params: { uuid: uuid } });
            let routeData = this.$router.resolve({
                name: "caseDetails",
                params: { uuid: uuid },
                query:{type:'cases'}
            });
            window.open(routeData.href, "_blank");
        },
        getNewsMore() {
            //this.$router.push("/news");
            let routeData = this.$router.resolve({
                name: "cases",
            });
            window.open(routeData.href, "_blank");
        }
    },
}

</script>
<style scoped lang="less">
.centent {
    width: 100%;
    height: 520px;
    background: url("../../assets/caseBack.jpg") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .carousel_box {
        width: 1200px;
        margin: 0 auto;
    }

    .carousel_item {
        width: 1200px;
        display: flex;
        align-items: center;

        .mesg_box {
            width: 600px;
            height: 400px;
            background: rgba(255, 255, 255, 0.7);
            padding: 50px 30px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            box-sizing: border-box;
            .title {
                font-size: 24px;
                font-weight: bold;
                font-family: PingFangSC-Medium, PingFang SC;
                margin-bottom: 22px;
            }

            .content {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                color: #6E6E6E;
                font-weight: 400;
                line-height: 32px;
                flex: 1;
                overflow: auto;
                // overflow: hidden;
                // text-overflow: ellipsis;
                // white-space: normal !important;
                // -webkit-line-clamp: 2;
                // -webkit-box-orient: vertical;
            }

            .tpis {
                color: #6E6E6E;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                line-height: 22px;
                cursor: pointer;
            }
        }

        img {
            width: 600px;
            height: 400px;
            object-fit: cover;
        }
    }

    .new_center_more {
        margin: 0 auto;
        width: 1200px;
        text-align: center;
        font-size: 12px;
        // color: #606060;
        color: #000;
        margin-bottom: 30px;
        margin-top: 10px;
        cursor: pointer;
        &:hover {
            color: #009999;
        }
    }
    /deep/.el-carousel__button {
        background-color: #009999;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homeIndex/caseCom.vue